import dashStyles from '../../Dashboard.module.css';
import v2ShellStyles from '../../OnboardingAgent/V2OnboardingAgent.module.css';
import { FALLBACK_THEME, FRAME_HEADER_FILL, PANEL_HEADER, STYLE_ID } from './constants';
import { forEachTawkIframe, isTawkHost, isTawkIframe } from './dom';
import { watchTawkComposer, enhanceTawkPanel } from './chrome';
import { watchTawkPhoneForm } from './phone';
import { themeCss, themeVarsCss } from './themeCss';

function cssVar(el, name, fallback) {
  if (!el || typeof getComputedStyle !== 'function') return fallback;
  const value = getComputedStyle(el).getPropertyValue(name).trim();
  return value || fallback;
}

function resolveThemeRoot(preferred) {
  if (typeof document === 'undefined') return preferred || null;
  const scope = preferred && preferred.querySelector ? preferred : document;
  return (
    scope.querySelector(`.${v2ShellStyles['v2-shell']}`) ||
    preferred ||
    document.querySelector(`.${dashStyles.dashboard}`) ||
    document.documentElement
  );
}

export function readTheme(preferred) {
  const root = resolveThemeRoot(preferred);
  return {
    primary: cssVar(root, '--v2-primary', cssVar(root, '--dash-primary', FALLBACK_THEME.primary)),
  };
}

export function injectStyle(doc, css) {
  if (!doc || !doc.createElement) return false;
  try {
    let style = doc.getElementById(STYLE_ID);
    if (!style) {
      style = doc.createElement('style');
      style.id = STYLE_ID;
    }
    if (style.textContent !== css) style.textContent = css;
    const parent = doc.head || doc.documentElement;
    if (style.parentNode !== parent || style.nextSibling) parent.appendChild(style);
    return true;
  } catch {
    return false;
  }
}

export function applyThemeToIframe(iframe, css) {
  try {
    iframe.style.colorScheme = 'light';
    iframe.style.setProperty(
      'background',
      `linear-gradient(to bottom, ${PANEL_HEADER} ${FRAME_HEADER_FILL}, #ffffff ${FRAME_HEADER_FILL})`,
      'important'
    );
    iframe.style.setProperty('background-color', '#ffffff', 'important');
    const doc = iframe.contentDocument;
    if (!doc) return;
    injectStyle(doc, css);
    if (doc.documentElement) doc.documentElement.style.colorScheme = 'light';
    if (doc.body) doc.body.style.colorScheme = 'light';
    watchTawkComposer(doc);
    watchTawkPhoneForm(doc);
    enhanceTawkPanel(doc);
  } catch {
    // Cross-origin iframe — expected.
  }
}

export function applyTheme(preferredRoot) {
  const theme = readTheme(preferredRoot);
  injectStyle(document, themeVarsCss(theme.primary));
  const css = themeCss(theme);
  forEachTawkIframe((iframe) => applyThemeToIframe(iframe, css));
}

function tawkIframeGroup(iframe) {
  if (isTawkHost(iframe.parentElement)) {
    return Array.from(iframe.parentElement.children).filter((n) => n.nodeName === 'IFRAME');
  }
  if (isTawkIframe(iframe)) return [iframe];
  return [];
}

export function collectAddedTawkIframes(mutations) {
  const found = [];
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      const iframes =
        node.nodeName === 'IFRAME'
          ? [node]
          : node.nodeType === 1 && node.querySelectorAll
            ? Array.from(node.querySelectorAll('iframe'))
            : [];
      for (const iframe of iframes) {
        found.push(...tawkIframeGroup(iframe));
      }
    }
  }
  return found;
}
